import axiosInstance from "../api/axiosInstance";
import { TRANSPORTERS } from "../constants/API_URLs";
export interface TransporterData {
  name: string;
  gst: string;
  state: string;
  city: string;
  mobileNumber: string;
  workingCity: string;
  address: string;
  status: boolean;
}

export const addTransporter = (data: TransporterData): Promise<any> => {
  return axiosInstance.post(TRANSPORTERS, data);
};

export const updateTransporter = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${TRANSPORTERS}/${id}`, data);
};

export const getTransporters = (params: any): Promise<any> => {
  return axiosInstance.get(TRANSPORTERS, { params });
};

export const getTransporter = (id: any): Promise<any> => {
  return axiosInstance.get(`${TRANSPORTERS}/${id}`);
};

export const deleteTransporter = (id: any): Promise<any> => {
  return axiosInstance.delete(`${TRANSPORTERS}/${id}`);
};

export const exportExcelTransporter = (params: any): Promise<any> => {
  return axiosInstance.get(`${TRANSPORTERS}/export/excel`, {
    params,
    responseType: "blob",
  });
};
